<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3 mr-3">
    <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
      <PageTitle title="Frete e entrega" />
    </b-col>
    <b-col cols="12" class="mb-5">
      <b-button
        class="mr-3"
        variant="danger"
        @click="$refs.videoManual.toggleOpen({
          url: 'https://www.youtube.com/watch?v=4sc3dGYUV7E&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=9',
          title: 'Transporte próprio da loja'
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Frete e Envio.pdf"
        target="_blank"
        download
        ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
      >
    </b-col>
    <!-- Retirada na loja -->
    <b-col cols="12" class="mt-4 mb-2">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h2 class="title font-weight-bold text-uppercase">Retirada na loja </h2>
          </b-col>
          <b-col cols="12" sm="12" md="12" class="form-group" v-if="whatClerkPermission()">
            <div class="d-flex align-items-center">
              <label class="font-weight-bold">
                Deseja que o cliente retire em sua loja? (grátis)
              </label>
              <b-form-checkbox
                switch
                v-model="fields.pickupInStore"
                size="lg"
                class="ml-3"
              ></b-form-checkbox>
            </div>
          </b-col>

          <b-col v-if="fields.pickupInStore" cols="12" class="form-group">
            <label class="fs-20 font-weight-bold">Prazo retirada em loja até</label>
            <div>
              <input
                :disabled="!whatClerkPermission()"
                type="number"
                class="form-control"
                style="width: 15%; float: left"
                v-model="fields.dRetirada"
                placeholder="Ex: 2"
              />
              <select
                :disabled="!whatClerkPermission()"
                name="select"
                class="form-control"
                style="width: 20%"
                v-model="fields.tRetirada"
              >
                <option value="hora(s)">Hora(s)</option>
                <option value="dia(s)">Dia(s)</option>
              </select>
              <error-message :errorMessage="requiredFields.retirada" />
            </div>
          </b-col>
          <b-col cols="12" v-if="fields.pickupInStore" class="mt-4">
            <span class="fs-20 font-weight-bold">Endereço Principal: </span>
            <span class="fs-20">
              {{ getMainAddress() }}
            </span>
          </b-col>
          <b-col cols="12" v-if="fields.pickupInStore" class="mt-3">
            <b-button
              variant="outline-success"
              @click="$refs.addressAdditional.toggleOpen({ data: [], idUser: userTypeId() })"
            >Adicionar endereço extra</b-button>
          </b-col>

          <b-col cols="12" class="mt-4 mb-2" v-if="fields.pickupInStore && table.records.length > 0">
            <b-table
              striped
              responsive
              hover
              :fields="table.headers"
              :items="table.records"
              :busy="loading"
            >
            <template #cell(name)="data">
              {{ data.item.name }}
            </template>

            <template #cell(address)="data">
              {{
                data.item.address + ", " +
                data.item.number + " - " +
                data.item.district + ", " +
                data.item.city + " - " +
                data.item.state + ", " +
                data.item.cep
              }}
            </template>

             <template #cell(action)="data">
              <b-button
                @click="$refs.addressAdditional.toggleOpen({ data: data.item, idUser: userTypeId() })"
                variant="outline-primary"
                class="mr-2 mt-1"
              >
                <i class="fas fa-edit"></i>
              </b-button>

              <b-button
                class="mt-1"
                variant="outline-danger"
                @click="$refs.deleteAddressAdditional.toggleOpen({
                  idAddress: data.item.id, idUser: userTypeId()
                })"
              >
                <i class="fas fa-trash"></i>
              </b-button>
            </template>
            </b-table>
          </b-col>
        </b-row>
        <AddressAdditionalModal @getAddress="getAddress()" ref="addressAdditional" />
        <DeleteAddressAdditionalModal @getAddress="getAddress()" ref="deleteAddressAdditional" />
      </b-card>
    </b-col>

    <!-- Transporte motoboy -->
    <b-col cols="12" class="mt-4 mb-2">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h2 class="title font-weight-bold text-uppercase">Motoboy</h2>
          </b-col>

          <b-col cols="12" sm="12" md="12">
            <label class="font-weight-bold">
              Deseja enviar por motoboy?
            </label>

            <br>

            <button :class="fields.motorcycle == true ? 'btn btn-danger' : 'btn btn-success'" @click="updateStatusMotorcycle()">
              {{fields.motorcycle == true ? 'Desativar envio por motoboy' : 'Sim, quero enviar por motoboy'}}
            </button>
          </b-col>

          <b-col cols="4" sm="4" md="4" class="mt-4">
            <label>Nome do frete:</label>
            <input type="text" class="form-control" v-model="fields.motorcycle_name" placeholder="Ex: Frete por CEP">
          </b-col>

          <b-col cols="12" sm="12" md="12" class="mt-2">
            <label>Icone do frete:</label><br>
            <input type="radio" name="motorcycle" value="1" v-model="fields.motorcycle_icon">
            <label class="ml-1 mr-3">Moto</label>
            <input type="radio" name="motorcycle" value="2" v-model="fields.motorcycle_icon">
            <label class="ml-1">Caminhão</label>
          </b-col>

          <b-col cols="4" sm="4" md="4" class="mt-4">
            <button class="btn btn-success btn-block" @click="updateMotorcycleData()">Salvar</button>
          </b-col>

          <b-col cols="12" v-if="fields.motorcycle" class="text-right">
            <button class="btn btn-primary" @click="showModalMotocycle()">Adicionar nova entrega</button>
          </b-col>

          <b-col cols="12" class="mt-2 mb-2" v-if="fields.motorcycle && fields.motorcycleZips.length > 0">

            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1" v-for="(item, i) in fields.motorcycleZips" :key="i">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="'accordion-' + i" variant="primary">
                    Nome: {{item.name}} /
                    Preço: {{formatPrice(item.price)}} /
                    Status:
                    <b-badge variant="success" v-if="item.status == true">Ativo</b-badge>
                    <b-badge variant="danger" v-else>Inativo</b-badge>
                  </b-button>
                </b-card-header>
                <b-collapse :id="'accordion-' + i" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button class="btn btn-primary mr-2" @click="editMotorcycle(item)">
                          Editar entrega
                        </button>

                        <button class="btn btn-success" @click="addZip(item.id)">
                          Adicionar faixa de cep
                        </button>
                      </div>

                      <div class="col-12 mt-2">
                        <table class="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th class="text-left">Faixa de cep:</th>
                              <th class="text-center">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(zip, i) in item.motorcycle_zips" :key="i">
                              <td class="text-left">
                                {{formatZip(zip.zip_start)}} - {{formatZip(zip.zip_end)}}
                              </td>
                              <td class="text-center" style="width: 150px">
                                <span class="btn btn-primary mr-1" @click="editZipBrand(zip)">
                                  <i class="fas fa-edit"></i>
                                </span>

                                <span class="btn btn-danger" @click="dellZipBrand(zip.id)">
                                  <i class="fas fa-trash"></i>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <!-- Transporte proprio -->
    <b-col cols="12" class="mt-2">
      <b-card>
        <b-row>
          <b-col cols="12" class="d-flex align-items-center">
            <h2 class="title font-weight-bold text-uppercase mb-3">Transporte próprio da loja</h2>
            <b-form-checkbox
              class="ml-3 mb-3"
              switch
              v-model="fields.ownTransport"
              size="lg"
            ></b-form-checkbox>
          </b-col>

          <b-col cols="12" :md="!shippingRuleActive ? '12' : '4'" class="mb-4 mt-3">
            <div class="d-flex align-items-center">
              <label class="font-weight-bold">
                Criar regras personalizadas para o frete?
              </label>
              <b-form-checkbox
                class="ml-3 mb-2"
                switch
                v-model="shippingRuleActive"
                @change="enableRuleFreight(TypeFreightTransport.STANDARD_SHIPPING)"
                size="lg"
              ></b-form-checkbox>
            </div>
          </b-col>
          <b-col v-if="fields.ownTransport && !shippingRuleActive" cols="12">
            <div class="d-flex align-items-center">
              <h5 class="font-weight-bold">
                Escolha o tipo de frete:
              </h5>
              <b-form-radio-group
                v-model="selectedFreight"
                :options="optionsFreight"
                buttons
                button-variant="outline-primary"
                class="ml-3 mb-2"
                @change="freightFree()"
              ></b-form-radio-group>
            </div>
          </b-col>
          <b-col v-if="fields.ownTransport && !shippingRuleActive" cols="12" sm="12" md="12" lg="4" xl="4" class="form-group">
            <div v-if="selectedFreight == 'fixed'">
              <label
                class="font-weight-bold">
                  Valor do frete (fixo)
              </label>
              <InputMoney
                :disabled="!whatClerkPermission() || selectedFreight == 'free'"
                v-model="fields.fixedFreight"
                @update:value="requiredFields.fixedFreight = ''"
              />
              <error-message :errorMessage="requiredFields.fixedFreight" />
            </div>
            <div v-else>
              <label
                class="font-weight-bold"
              >Valor do frete por KM</label>
              <InputMoney
                :disabled="!whatClerkPermission() || selectedFreight == 'free'"
                v-model="fields.freightKilometer"
                @update:value="requiredFields.freightKilometer = ''"
              />
              <error-message :errorMessage="requiredFields.freightKilometer" />
            </div>
          </b-col>
          <b-col v-if="fields.ownTransport" cols="12" sm="12" md="12" lg="4" xl="4" class="form-group">
            <div class="d-flex align-items-center">
              <label class="font-weight-bold">
                Frete gratis a partir de (valor de compra)?
              </label>
              <b-form-checkbox
                switch
                v-model="inputStatus"
                @change="inputStatus == false ? fields.freightValueToFree = '' : ''"
                size="md"
                class="ml-3"
                :disabled="!whatClerkPermission() || selectedFreight == 'free'"
              ></b-form-checkbox>
            </div>
            <InputMoney
              :disabled="inputStatus == false"
              v-model="fields.freightValueToFree"
              @update:value="requiredFields.freightValueToFree = ''"
            />
            <error-message :errorMessage="requiredFields.freightValueToFree" />
          </b-col>
          <!-- <b-col v-if="fields.ownTransport" cols="12" sm="6" md="6" lg="6" xl="6" class="form-group">
            <label class="font-weight-bold">Prazo retirada em loja até</label>
            <div>
              <input
                :disabled="!whatClerkPermission()"
                type="number"
                class="form-control"
                style="width: 50%; float: left"
                v-model="fields.dRetirada"
                placeholder="Ex: 2"
              />
              <select
                :disabled="!whatClerkPermission()"
                name="select"
                class="form-control"
                style="width: 50%"
                v-model="fields.tRetirada"
              >
                <option value="hora(s)">Hora(s)</option>
                <option value="dia(s)">Dia(s)</option>
              </select>
              <error-message :errorMessage="requiredFields.retirada" />
            </div>
          </b-col> -->
          <b-col v-if="fields.ownTransport" cols="12" sm="12" md="12" lg="4" xl="4" class="form-group">
            <label class="font-weight-bold">Prazo para entrega até</label>
            <div>
              <input
                :disabled="!whatClerkPermission()"
                type="number"
                class="form-control"
                style="width: 50%; float: left"
                v-model="fields.dEntrega"
                placeholder="Ex: 2"
              />
              <select
                :disabled="!whatClerkPermission()"
                name="select"
                class="form-control"
                style="width: 50%"
                v-model="fields.tEntrega"
              >
                <option value="hora(s)">Hora(s)</option>
                <option value="dia(s)">Dia(s)</option>
              </select>
              <error-message :errorMessage="requiredFields.entrega" />
            </div>
          </b-col>
          <b-col v-if="shippingRuleActive" cols="12" class="mb-2">
            <FreightRulesComponent
              class="mt-2"
              :whatClerkPermission="whatClerkPermission()"
              :shopkeeperId="userTypeId()"
              :rulesFreight="getRuleTruck()"
              :typeFreightTransport="TypeFreightTransport.STANDARD_SHIPPING"
              :idTypeFreight="idTypeFreight"
              @getRules="getFreightRule()"
            />
          </b-col>
          <b-col cols="12" class="mb-4 mt-2" v-if="!shippingRuleActive && fields.latitude != null && fields.ownTransport">
            <GoogleMap
              localStorageKey="shopkeeperFreight"
              :latitude.sync="fields.latitude"
              :longitude.sync="fields.longitude"
              :address.sync="fields.address"
              :radius.sync="fields.radius"
              :isPermissionClerk="!whatClerkPermission()"
            />
            <error-message :errorMessage="requiredFields.radius" />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <!-- Frete por Caminhão -->
    <b-col cols="12" class="mt-3">
      <FreightTruck
        :whatClerkPermission="whatClerkPermission()"
        :shopkeeperId="userTypeId()"
        :freightTruck="freightRules"
        :freightActive="shippingTruckActive"
        :volume-truck="volumeTruck"
        @getRules="getFreightRule()"
        @saveVolume="saveVolumeTruck($event)"
        @enableDisableTruck="
          shippingTruckActive = !shippingTruckActive,
          enableRuleFreight(TypeFreightTransport.EXCLUSIVE_TRUCK)
        "
      />
    </b-col>
    <b-col cols="12" class="mb-4 mt-2">
      <MelhorEnvioConfiguration :isPermissionClerk="!whatClerkPermission()" />
    </b-col>
    <b-col cols="12" class="mb-2" v-if="whatClerkPermission()">
      <b-button size="lg" block variant="success" @click="save()">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
    <VideoManual ref="videoManual"/>

    <b-modal id="regra-motoboy" title="Entrega motoboy" hide-footer>
      <b-row >
        <b-col cols="8" class="mb-2">
          <label>Nome da entrega:</label>
          <input type="text" class="form-control" v-model="motorcycle.name" placeholder="Ex: Entrega para o centro">
        </b-col>

        <b-col cols="4" class="mb-2">
          <label>Preço:</label>
          <input type="text" class="form-control" v-model="motorcycle.price" v-money="money">
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Valor min. para frete grátis:</label>
          <input type="text" class="form-control" v-model="motorcycle.min_price" v-money="money">
        </b-col>

        <b-col cols="4" class="mt-2">
          <label>Dias frete grátis:</label>
          <input
            type="number"
            v-mask="['##']"
            class="form-control"
            v-model="motorcycle.days_free"
            placeholder="Ex: 2"
          >
        </b-col>

        <b-col cols="2" class="mt-2">
          <label>Status </label>
          <input type="checkbox" class="ml-2" v-model="motorcycle.status">
        </b-col>

        <b-col cols="12" class="mt-4">
          <div class="d-flex align-items-center">
            <b-form-group
              label="Selecione os dias da semana para entrega:"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="motorcycle.days_week"
                :options="optionsDaysMotorcycle"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                buttons
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="12" class="text-center mt-4">
          <b-button class="" variant="success" block @click="saveMotorcycle()">Salvar</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="zip-brand" title="Faixa de cep" hide-footer>
      <div class="row">
        <div class="col-12 mb-2 cursor-pointer" @click="searchZip()">
          <b-alert variant="danger" show>Não sabe a faixa de cep? <b>Clique aqui!</b></b-alert>
        </div>

        <div class="col-6 mb-2">
          <label>Cep início:</label>
          <input type="text" class="form-control" v-model="brand.zip_start" v-mask="'#####-###'" placeholder="#####-###">
        </div>

        <div class="col-6 mb-2">
          <label>Cep fim:</label>
          <input type="text" class="form-control" v-model="brand.zip_end" v-mask="'#####-###'" placeholder="#####-###">
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success" @click="saveZipBrand()">Salvar</button>
        </div>
      </div>
    </b-modal>

  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import makeToast from '../../../mixins/makeToast';
import ErrorMessage from '../../../components/ErrorMessage.vue';

import GoogleMap from 'Components/Inputs/GoogleMap.vue';
import PageTitle from '../../../components/PageTitle.vue';
import InputMoney from '../../../components/Inputs/InputMoney.vue';
import MelhorEnvioConfiguration from './MelhorEnvioConfiguration.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import VideoManual from '@/components/VideoManual.vue';
import AddressAdditionalModal from '@/components/Shopkeeper/AddressAdditionalModal.vue';
import DeleteAddressAdditionalModal from '@/components/Shopkeeper/DeleteAddressAdditionalModal.vue';
import FreightTruck from '@/components/Freight/FreightTruck.vue';
import TypeFreightTransport from '@/enums/TypeFreightTransport';
import FreightRulesComponent from '@/components/Freight/FreightRulesComponent.vue';

export default {
  name: 'FreightSave',
  mixins: [makeToast],
  components: {
    PageTitle,
    ErrorMessage,
    InputMoney,
    GoogleMap,
    MelhorEnvioConfiguration,
    VideoManual,
    AddressAdditionalModal,
    DeleteAddressAdditionalModal,
    FreightTruck,
    FreightRulesComponent
  },
  data() {
    return {
      TypeFreightTransport,
      loading: false,
      shippingRuleActive: false,
      shippingTruckActive: false,
      idTypeFreight: null,
      inputPrice: false,
      openMotorcycle: false,
      inputStatus: true,
      selectedFreight: 'fixed',
      optionsDaysMotorcycle: [
        { text: 'Dom', value: '1' },
        { text: 'Seg', value: '2' },
        { text: 'Ter', value: '3' },
        { text: 'Qua', value: '4' },
        { text: 'Qui', value: '5' },
        { text: 'Sex', value: '6' },
        { text: 'Sab', value: '7' }
      ],
      fields: {
        pickupInStore: '',
        fixedFreight: '',
        freightKilometer: '',
        freightValueToFree: '',
        dRetirada: '',
        dEntrega: '',
        tRetirada: '',
        tEntrega: '',
        address: '',
        ownTransport: false,
        latitude: null,
        longitude: null,
        radius: 0,
        motorcycle_name: '',
        motorcycle_icon: '1',
        motorcycle: false,
      },
      optionsFreight: [
        { text: 'Fixo', value: 'fixed' },
        { text: 'Km', value: 'km' },
        { text: 'Grátis', value: 'free' },
      ],
      requiredFields: {
        fixedFreight: '',
        freightKilometer: '',
        freightValueToFree: '',
        entrega: '',
        retirada: '',
        radius: '',
      },
      motorcycle: {
        id: null,
        name: '',
        status: true,
        price: '',
        construp_user_id: null,
        days_free: null,
        min_price: null,
        days_week: [],
      },
      freightRules: [],
      brand: {
        id: null,
        zip_start: '',
        zip_end: '',
        motorcycle_id: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      table: {
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'name',
            label: 'Nome',
            sortable: false,
          },
          {
            key: 'address',
            label: 'Endereço ',
            sortable: false,
          },
          {
            key: 'action',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddress']),
  },
  mounted() {
    this.get();
    this.getAddress();
    this.getFreightRule();
  },
  methods: {
    ...mapActions('shopkeeper',
      [
        'setStatusMotorcicle',
        'saveMotorcycleForm',
        'saveZipBrandForm',
        'updateMotorcycle',
        'zipBrandDell',
        'saveFreight',
        'getFreight',
        'getAddressAdditional',
        'deleteAddressAdditional',
        'updateAddressAdditional',
        'createAddressAdditional',
        'getAllShopkeeperFreightRule',
        'enableOrDisableFreightRule',
        'getAddressAdditionalShopkeeper'
      ]
    ),
    updateMotorcycleData() {
      const data = {
        motorcycle_name: this.fields.motorcycle_name,
        motorcycle_icon: this.fields.motorcycle_icon,
        construp_user_id: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.updateMotorcycle(data)
        .then((response) => {
          if(response.error == true) {
            this.makeToast('Opss', 'Houve um erro ao atualizar frete!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Frete atualizado com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar o frete!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    freightFree() {
      if (this.selectedFreight == 'free') {
        this.inputStatus = false;
        this.fields.fixedFreight = '';
        this.fields.freightKilometer = '';
        this.fields.freightValueToFree = '';
      }
    },
    updateStatusMotorcycle() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.setStatusMotorcicle(this.userTypeId())
        .then((response) => {
          if(response.error == true) {
            this.makeToast('Opss', 'Houve um erro ao atualizar status!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Status atualizado com sucesso!', 'success');
            this.fields.motorcycle = !this.fields.motorcycle;
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar status!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    dellZipBrand(id) {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.zipBrandDell(id)
        .then((response) => {
          if(response.error == true) {
            this.makeToast('Opss', 'Houve um erro ao excluir a faixa de cep!', 'danger');

            this.$store.dispatch('endLoader');
            this.loading = false;
          } else {
            this.makeToast('Sucesso', 'Faixa de cep excluida com sucesso!', 'success');

            this.get();
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao a faixa de cep!', 'danger');

          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    saveMotorcycle() {
      if(this.motorcycle.name == ''){
        this.makeToast('Opss', 'Informe um nome para a regra', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.motorcycle.construp_user_id = this.userTypeId();

      if(this.motorcycle.price == '0,00') {
        this.motorcycle.price = null;
      }

      if(this.motorcycle.min_price == '0,00') {
        this.motorcycle.min_price = null;
      }

      if(!this.motorcycle.days_free) {
        this.motorcycle.days_free = null;
      }

      if(!this.motorcycle.days_week) {
        this.motorcycle.days_week = [];
      }

      this.saveMotorcycleForm(this.motorcycle)
        .then((response) => {
          if(response.error == true) {
            this.makeToast('Opss', 'Houve um erro ao inserir regra do motoboy!', 'danger');

            this.$store.dispatch('endLoader');
            this.loading = false;
          } else {
            var msg = 'Nova regra criada com sucesso!';
            if(this.motorcycle.id != null) {
              var msg = 'Regra atualizada com sucesso!';
            }

            this.makeToast('Sucesso', msg, 'success');

            this.$bvModal.hide('regra-motoboy');

            this.get();
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar status!', 'danger');
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    saveZipBrand() {
      if(this.brand.zip_start == '' || this.brand.zip_end == ''){
        this.makeToast('Opss', 'Informe a faixa de cep', 'danger');
        return;
      }

      if(this.brand.zip_start.length != 9 || this.brand.zip_end.length != 9){
        this.makeToast('Opss', 'Informe uma faixa de cep valida', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.saveZipBrandForm(this.brand)
        .then((response) => {
          if(response.error == true) {
            this.makeToast('Opss', 'Houve um erro ao inserir faixa de cep!', 'danger');

            this.$store.dispatch('endLoader');
            this.loading = false;
          } else {
            var msg = 'Nova faixa de cep criada com sucesso!';
            if(this.brand.id != null) {
              var msg = 'Faixa de cep atualizada com sucesso!';
            }

            this.makeToast('Sucesso', msg, 'success');

            this.$bvModal.hide('zip-brand');

            this.get();
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar status!', 'danger');
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    showModalMotocycle() {
      this.motorcycle.id = null;
      this.motorcycle.name = '';
      this.motorcycle.status = true;
      this.motorcycle.price = '';
      this.motorcycle.days_free = null;
      this.motorcycle.min_price = null;
      this.motorcycle.days_week = [];

      this.$bvModal.show('regra-motoboy');
    },
    editMotorcycle(item) {
      this.motorcycle.id = item.id;
      this.motorcycle.name = item.name;
      this.motorcycle.status = item.status;
      this.motorcycle.price = item.price;
      this.motorcycle.days_free = item.days_free;
      this.motorcycle.min_price = item.min_price;
      this.motorcycle.days_week = item.days_week ? item.days_week.split(',') : [];

      this.$bvModal.show('regra-motoboy');
    },
    editZipBrand(item) {
      this.brand.id = item.id;
      this.brand.zip_start = item.zip_start;
      this.brand.zip_end = item.zip_end;
      this.brand.motorcycle_id = item.motorcycle_id;

      this.$bvModal.show('zip-brand');
    },
    addZip(id) {
      this.brand.id = null;
      this.brand.zip_start = '';
      this.brand.zip_end = '';
      this.brand.motorcycle_id = id;

      this.$bvModal.show('zip-brand');
    },
    formatPrice(price){
      if(price != null) {
        const money = parseFloat(price);
        var newValue = money.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        return newValue;
      }

      return 'Grátis';
    },
    formatZip(zip){
      const cepFormatado = zip.replace(/^(\d{5})(\d{3})$/, '$1-$2');

      return cepFormatado;
    },
    searchZip() {
      var url = "https://www2.correios.com.br/sistemas/buscacep/buscaFaixaCep.cfm";
      window.open(url, '_blank');
    },
    get() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getFreight(this.userTypeId())
        .then((response) => {
          this.fields = response.data.data || {};
          this.selectedFreight = this.fields.freightKilometer ? "km" : "fixed";
          this.inputStatus = this.fields.freightValueToFree > 0 ? true : false;
          this.fields.ownTransport = response.data.data.ownTransport == 1 ? true : false;
          this.fields.pickupInStore = !!this.fields.pickupInStore;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados sobre a empresa',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save() {
      if (!this.validateFields()) {
        this.makeToast(
          'Erro',
          'Tem campos obrigatórios a serem preenchido!',
          'danger'
        );
        return;
      }

      this.checkSelectFields();

      const request = {
        userId: this.userTypeId(),
        ...this.fields,
        longitude: parseFloat(this.fields.longitude),
        latitude: parseFloat(this.fields.latitude),
        radius: parseInt(this.fields.radius, 10),
        status: this.inputStatus,
      };

      this.$store.dispatch('startLoader');

      this.saveFreight(request)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Informações sobre o frete salvas com sucesso'
          );
          this.$root.$emit('valid-available-app');
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    checkSelectFields() {
      if(!this.fields.pickupInStore) {
        this.fields.dRetirada =  null;
        this.fields.tRetirada = null;
      }

      if(this.fields.ownTransport) {
        if(this.selectedFreight == "km") {
        this.fields.fixedFreight = "R$0,00";
        }else {
          this.fields.freightKilometer = "R$0,00";
        }
      } else {
        this.fields.fixedFreight = "R$0,00";
        this.fields.freightKilometer = "R$0,00";
        this.fields.freightValueToFree = "R$0,00";
        this.fields.dEntrega =  null;
        this.fields.tEntrega =  null;
        this.fields.latitude =  null;
        this.fields.longitude =  null;
        this.fields.radius = 0;
      }
    },
    /** @return {Boolean} */
    validateFields() {
      this.limparErros();

      let valid = true;

      if(this.fields.pickupInStore) {
        if (this.fields.dRetirada == '' || this.fields.dRetirada == undefined) {
          this.requiredFields.retirada = 'Campo obrigatório';
          valid = false;
        }

        if (this.fields.tRetirada == '' || this.fields.tRetirada == undefined) {
          this.requiredFields.retirada = 'Campo obrigatório';
          valid = false;
        }
      }

      if(this.fields.ownTransport) {
        if (this.fields.dEntrega == '' || this.fields.dEntrega == undefined) {
          this.requiredFields.entrega = 'Campo obrigatório';
          valid = false;
        }

        if (this.fields.tEntrega == '' || this.fields.tEntrega == undefined) {
          this.requiredFields.entrega = 'Campo obrigatório';
          valid = false;
        }

        if(this.selectedFreight == "fixed" && (!this.fields.fixedFreight || this.fields.fixedFreight == 'R$0,00')) {
          this.requiredFields.fixedFreight = 'Campo obrigatório';
          valid = false;
        }

        if(this.selectedFreight == "km" && (!this.fields.freightKilometer || this.fields.freightKilometer == 'R$0,00')) {
          this.requiredFields.freightKilometer = 'Campo obrigatório';
          valid = false;
        }

        if(this.fields.radius == 0) {
          this.requiredFields.radius = 'O raio não pode ser menor que 1(um)';
          valid = false;
        }
      }
      return valid;
    },
    limparErros() {
      this.requiredFields.entrega = '';
      this.requiredFields.retirada = '';
      this.requiredFields.freightValueToFree = '';
      this.requiredFields.fixedFreight = '';
      this.requiredFields.freightKilometer = '';
      this.requiredFields.radius = '';
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo obrigatório');
      });
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.FRETE);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    },
    getMainAddress() {
      if(this.$route.meta.userType  == UserTypes.BALCONISTA) {
        return this.dadosUsuario.lojista.endereco + ", " + 
          this.dadosUsuario.lojista.numero + " - " +
          this.dadosUsuario.lojista.bairro + ", " +
          this.dadosUsuario.lojista.cidade.nome + " - " +
          this.dadosUsuario.lojista.estado.uf + ", " +
          this.dadosUsuario.lojista.bairro;
      }
      return this.dadosUsuario.informacoes.endereco + ", " + 
        this.dadosUsuario.informacoes.numero + " - " +
        this.dadosUsuario.informacoes.bairro + ", " +
        this.dadosUsuario.informacoes.cidade.nome + " - " +
        this.dadosUsuario.informacoes.estado.uf + ", " +
        this.dadosUsuario.informacoes.bairro;
    },
    getAddress() {
      this.$store.dispatch('startLoader');
      this.loading = true;
      
      const getAddressShopkeeper = this.$route.meta.userType  == UserTypes.BALCONISTA ?
        this.getAddressAdditionalShopkeeper(this.userTypeId()) : 
        this.getAddressAdditional(this.userTypeId());

      getAddressShopkeeper.then((response) => {
          this.table.records = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os endereços da empresa',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    getFreightRule() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getAllShopkeeperFreightRule(this.userTypeId())
        .then((response) => {
          this.freightRules = response.data.data.data || [];

          this.freightRules.map((item) => {
            if(item.type === TypeFreightTransport.EXCLUSIVE_TRUCK) {
              this.shippingTruckActive = item.status == 1 ? true : false;
              this.volumeTruck = item.volume;
            }
            if(item.type === TypeFreightTransport.STANDARD_SHIPPING) {
              this.shippingRuleActive = item.status  == 1 ? true : false;
            }
          });
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados da regra de frete',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    enableRuleFreight(type, volume = null) {
      this.$store.dispatch('startLoader');
      this.loading = true;
      const dataFreight = this.freightRules.find((item) => item.type === type);

      const data = {
        "id": dataFreight ? dataFreight.id : null,
        "construp_user_id": this.userTypeId(),
        "type": type,
        "volume": volume == 0 || !volume ? null : volume,
        "status": type === TypeFreightTransport.STANDARD_SHIPPING ?
          this.shippingRuleActive : this.shippingTruckActive
      }

      this.enableOrDisableFreightRule(data)
        .then((response) => {
          if(!response.data.data.error) {
            this.getFreightRule();

            this.makeToast(
              'Sucesso',
              'Atualizado com sucesso',
              'success'
            );
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar os dados',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    getRuleTruck() {
      let data = [];
      this.freightRules.map((item) => {
        if(item.type === TypeFreightTransport.STANDARD_SHIPPING) {
          this.idTypeFreight = item.id;
          data = item.freight_rules
        }
      });
      return data;
    },
    saveVolumeTruck(volume) {
      this.enableRuleFreight(TypeFreightTransport.EXCLUSIVE_TRUCK, volume);
    }
  },
};
</script>
